export default "__VITE_PUBLIC_ASSET__2850fdfd__"